import { Component, Inject, viewChild } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';

import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { SalesOrderService } from '../../features/salesOrder/services/salesOrder.service';
import { CommonModule, DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ActionTypeEnum } from '../../../assets/enum/actionTypeEnum';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { UploadFileService } from '../../shared/services/file-upload.service';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';

@Component({
  selector: 'app-order-flow-assigned-view',
  standalone: true,
  imports: [
    MatMenuModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    DatePipe,
  ],
  templateUrl: './order-flow-assigned-view.component.html',
  styleUrl: './order-flow-assigned-view.component.scss',
})
export class OrderFlowAssignedViewComponent {
  taskAssignmentId: any;
  orderData: any;
  taskAssignmentData: any;
  changeStatusForm: FormGroup;
  actorId: any;
  taskTimelineData: any;
  attachmentData: any;
  actions = ActionTypeEnum;
  notesData: any;
  addNoteForm: FormGroup;
  loading: Boolean = false;
  fileLoading: Boolean = false;
  tasksForm!: FormGroup;
  attachment: any;
  attachmentUrl: any;
   canListTimelineOrderFlow$ = this.permissionService.hasPermission(
      ModuleIds.OrderFlow,
      'Timeline'
    );
    canSendNoteOrderFlow$ = this.permissionService.hasPermission(
      ModuleIds.OrderFlow,
      'Send'
    );
  canUploadOrderFlow$ = this.permissionService.hasPermission(
      ModuleIds.OrderFlow,
      'Upload'
    );
    canCreateActivityOrderFlow$ = this.permissionService.hasPermission(
      ModuleIds.OrderFlow,
      'Create'
    );

  constructor(
    public dialog: MatDialog,
    public route: ActivatedRoute,
    private salesOrderService: SalesOrderService,
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private documentUploadService: UploadFileService,
    private permissionService: PermissionService
  ) {}

  ngOnInit() {
    const loggedInUser: any = localStorage.getItem('loggedInUser');
    const userData = JSON.parse(loggedInUser);
    this.actorId = userData?.employeeId;

    this.route.queryParamMap.subscribe((queryParams) => {
      const orderServiceId = queryParams.get('orderServiceId');
      this.taskAssignmentId = queryParams.get('id');
      if (this.taskAssignmentId) {
        const id = +this.taskAssignmentId;
        this.fetchOrderById(orderServiceId);
        this.serviceTaskAssignment(id);
        this.taskTimelines();
      }
    });

    const taskItems =
      this.taskAssignmentData?.serviceTaskData?.taskData?.taskCheckListItems ||
      [];

    this.tasksForm = this.fb.group({
      tasks:  this.fb.array([])  
    });
    this.changeStatusForm = this.fb.group({
      status: [''],
    });

    this.addNoteForm = this.fb.group({
      message: ['', Validators.required],
      actorId: [Number(this.actorId)],
      assignmentId: [Number(this.taskAssignmentId)],
      actionType: [ActionTypeEnum.Commented],
    });
  }

  get tasksFormArray(): FormArray {
    return this.tasksForm.get('tasks') as FormArray;
  }

  confirmChange(event: any) {
    const status = event.value;
    const dialogRef = this.dialog.open(ConfirmDialog, {
      width: '500px',
      data: {
        title: 'Confirm Change Status?',
        message:
          'Are you sure you want to change the status to ' + status + ' ?',
        confirmText: 'Change Status',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.changeStatus(status);
      }
    });
  }
  changeStatus(status: string) {
    const id = Number(this.taskAssignmentId);

    const updatePayload = {
      id,
      serviceTaskStatus: status,
    };

    const timelinePayload = {
      assignmentId: id,
      actionType: 'StatusChanged',
      actorId: this.actorId,
      message: `Status changed to ${status}`,
    };

    this.salesOrderService
      .modifyTaskAssignment(id, updatePayload, timelinePayload)
      .subscribe({
        next: () => {
          this.toastr.success('Status changed successfully');
          this.serviceTaskAssignment(id); // reload updated data
        },
        error: (error) => this.toastr.error(error?.message),
      });
  }

  fetchOrderById(id: any) {
    this.salesOrderService.getSalesOrderById(Number(id)).subscribe({
      next: (data) => {
        this.orderData = data;
      },
      error: (error) => {
        if (error?.message === 'No match found') {
          this.router.navigate([`sales-order`]);
        }
      },
    });
  }

  serviceTaskAssignment(orderId: number) {
    this.salesOrderService.serviceTaskAssignment(orderId).subscribe({
      next: (data) => {
        this.taskAssignmentData = data;
  
        const items = data?.serviceTaskData?.taskData?.taskCheckListItems || [];
        const isReviewOrCompleted =
          data?.serviceTaskStatus === 'Review' ||
          data?.serviceTaskStatus === 'Completed';
  
        // build a NEW FormArray
        const taskControls = items.map(() => {
          const control = this.fb.control(false);
          if (isReviewOrCompleted) {
            control.setValue(true);
            control.disable();
          }
          return control;
        });
  
        // reset parent form with new FormArray
        this.tasksForm = this.fb.group({
          tasks: this.fb.array(taskControls),
        });
  
        console.log('form rebuilt:', this.tasksForm.value);
      },
      error: (error) => {
        if (error?.message === 'No match found') {
          this.router.navigate(['sales-order']);
        }
      },
    });
  }
  
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // Validate the file size (10 MB = 10 * 1024 * 1024 bytes)
      const maxSizeInMB = 10;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

      if (file.size > maxSizeInBytes) {
        console.error('File size exceeds the maximum limit of 10 MB.');
        this.toastr.warning(
          'The selected file exceeds the maximum size of 10 MB. Please choose a smaller file.'
        );
        return;
      }

      // Handle the file, e.g., upload it or read it
      this.attachment = file;
      const reader = new FileReader();
      reader.readAsDataURL(this.attachment);
      reader.onload = (event: any) => {
        // this.attachment = event.target.result;
        console.log('Selected file:', this.attachment);
        this.onUpload();
      };
    }
  }

  onUpload() {
    if (this.attachment) {
      this.fileLoading = true;
      this.documentUploadService
        .uploadDocument(this.attachment, 'order-attachments')
        .subscribe({
          next: (response) => {
            this.attachmentUrl = response.url;
            this.fileUpload();
            this.fileLoading = false;
          },
          error: (error) => {
            this.toastr.error(error, 'Error');
            this.fileLoading = false;
          },
        });
    }
  }

  fileUpload() {
    this.loading = true;
    const taskAssignmentId = Number(this.taskAssignmentId);
    const CreateTaskTimelineInput = {
      assignmentId: taskAssignmentId,
      actionType: ActionTypeEnum.FileUploaded,
      actorId: this.actorId,
      message: `File uploaded successfully`,
      attachmentUrls: this.attachmentUrl,
    };

    this.salesOrderService.createActivity(CreateTaskTimelineInput).subscribe({
      next: (data: any) => {
        this.toastr.success('File uploaded successfully');
        this.taskTimelines();
      },
      error: (error: any) => {
        this.toastr.error(error?.message);
      },
    });
  }

  viewDocument(url: any) {
    const token = localStorage.getItem('AUTH_TOKEN');
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      })
      .catch((error) => console.error('Error:', error));
  }

  confirmRemove(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      width: '500px',
      data: {
        title: 'Confirm Remove Attachment?',
        message: 'Are you sure you want to remove the attachment?',
        confirmText: 'Remove',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.removeTaskTimeline(id);
      }
    });
  }

  removeTaskTimeline(id: any) {
    this.salesOrderService.removeTaskTimeline(id).subscribe({
      next: (data) => {
        this.toastr.success('File removed successfully');
        this.taskTimelines();
      },
      error: (error: any) => {
        this.toastr.error(error?.message);
      },
    });
  }

  taskTimelines() {
    const search = '';
    const id = Number(this.taskAssignmentId);
    const actionTypes = [
      ActionTypeEnum.DriverAssigned,
      ActionTypeEnum.DriverChanged,
      ActionTypeEnum.PickupScheduled,
      ActionTypeEnum.PickupCompleted,
      ActionTypeEnum.SubmissionCompleted,
      ActionTypeEnum.DocumentRejected,
      ActionTypeEnum.ResubmissionScheduled,
      ActionTypeEnum.CustomerContacted,
      ActionTypeEnum.CustomerUnreachable,
      ActionTypeEnum.MeetingScheduled,
      ActionTypeEnum.CallBackRequested,
      ActionTypeEnum.FileUploaded,
      ActionTypeEnum.FileRemoved,
      ActionTypeEnum.DocVerified,
      ActionTypeEnum.DocRejected,
      ActionTypeEnum.Rescheduled,
      ActionTypeEnum.Commented,
    ];

    this.salesOrderService.taskTimelines(search, id, actionTypes).subscribe({
      next: (data) => {
        // Notes: only Commented
        this.notesData = data.filter(
          (item: any) => item.actionType === ActionTypeEnum.Commented
        );

        // Activities: exclude Commented
        this.taskTimelineData = data.filter(
          (item: any) =>
            item.actionType !== ActionTypeEnum.Commented &&
            item.actionType !== ActionTypeEnum.FileUploaded
        );

        this.attachmentData = data.filter(
          (item: any) => item.actionType === ActionTypeEnum.FileUploaded
        );

        console.log('this.attachmentData', this.attachmentData);
      },
      error: (error) => {
        if (error?.message === 'No match found') {
          this.router.navigate([`sales-order`]);
        }
      },
    });
  }

  formatActionType(actionType: string): string {
    if (!actionType) return '--';
    return actionType.replace(/([a-z])([A-Z])/g, '$1 $2'); // insert space before capital letters
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(OrderFlowDialog, {
      width: '500px',
      data: { id: this.taskAssignmentId },
    });
  }
  openDialogActivity(): void {
    const dialogRef = this.dialog.open(AddActivityDialog, {
      width: '500px',
      data: { id: this.taskAssignmentId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.taskTimelines();
    });
  }

  addNote() {
    this.loading = true;
    const createTaskTimelineInput = this.addNoteForm.value;
    this.salesOrderService.createActivity(createTaskTimelineInput).subscribe({
      next: (data: any) => {
        this.addNoteForm.reset();
        this.taskTimelines();
        this.loading = false;
      },
      error: (error: any) => {
        this.toastr.error(error?.message);
      },
    });
  }

  allTasksChecked(): boolean {
    if (!this.tasksFormArray || this.tasksFormArray.length === 0) {
      return false;
    }

    const values = this.tasksFormArray.getRawValue(); // includes disabled controls
    console.log('raw values:', this.tasksFormArray.getRawValue());
    console.log('status:', this.taskAssignmentData?.serviceTaskStatus);
    return values.every((val: boolean) => val === true);
  }

  markAsCompleted() {
    this.loading = true;
    const taskAssignmentId = Number(this.taskAssignmentId);
    const updateServiceTaskAssignmentInput = {
      id: taskAssignmentId,
      serviceTaskStatus: 'Review',
    };
    const CreateTaskTimelineInput = {
      assignmentId: taskAssignmentId,
      actionType: ActionTypeEnum.Reviewed,
      actorId: this.actorId,
      message: `Status changed from ${this.taskAssignmentData?.serviceTaskStatus} to Reviewed`,
    };
    this.salesOrderService
      .modifyTaskAssignment(
        taskAssignmentId,
        updateServiceTaskAssignmentInput,
        CreateTaskTimelineInput
      )
      .subscribe({
        next: (data) => {
          this.toastr.success('Successfully completed');
          this.serviceTaskAssignment(taskAssignmentId);
          this.loading = false;
          this.router.navigate([`/order-flow-assigned-list`]);
        },
        error: (error: any) => {
          this.toastr.error(error?.message);
        },
      });
  }
}

@Component({
  selector: 'order-flow-dialog',
  templateUrl: './order-flow-assgined-dialog.html',
  styleUrl: './order-flow-assigned-view.component.scss',
  imports: [DatePipe, CommonModule],
  standalone: true,
})
export class OrderFlowDialog {
  timelineData: any;
  constructor(
    public dialogRef: MatDialogRef<OrderFlowDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private salesOrderService: SalesOrderService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.taskTimelines();
  }

  taskTimelines() {
    const search = '';
    const id = Number(this.data.id);
    const actionTypes = [
      ActionTypeEnum.Reviewed,
      ActionTypeEnum.Rejected,
      ActionTypeEnum.Approved,
      ActionTypeEnum.Reopened,
      ActionTypeEnum.Completed,
      ActionTypeEnum.Started,
      ActionTypeEnum.Unassigned,
      ActionTypeEnum.Reassigned,
      ActionTypeEnum.Assigned,
    ];

    this.salesOrderService.taskTimelines(search, id, actionTypes).subscribe({
      next: (data) => {
        this.timelineData = data;
      },
      error: (error) => {
        this.toastr.error(error?.message);
      },
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'add-activity-dialog',
  templateUrl: './add-activity-dialog.html',
  styleUrl: './order-flow-assigned-view.component.scss',
  standalone: true,
  imports: [
    MatMenuModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ],
})
export class AddActivityDialog {
  activityForm: FormGroup;
  actorId: any;
  drivers: any;

  constructor(
    public dialogRef: MatDialogRef<AddActivityDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private salesOrderService: SalesOrderService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    const userData: any = localStorage.getItem('loggedInUser');
    const user = JSON.parse(userData);
    this.actorId = user?.employeeId;

    this.activityForm = this.fb.group({
      actionType: ['', Validators.required],
      message: [''],
      assignmentId: [Number(this.data.id)],
      actorId: [Number(this.actorId)],
      performerId: [''],
    });

    this.fetchDrivers();
  }

  fetchDrivers() {
    this.salesOrderService.findOneByDesignation('Driver').subscribe({
      next: (data: any) => {
        this.drivers = data;
      },
      error: (error: any) => {
        this.toastr.error(error?.message);
      },
    });
  }
  onSubmit() {
    if (this.activityForm.invalid) {
      this.activityForm.markAllAsTouched();
      return;
    }
    const createTaskTimelineInput = this.activityForm.value;
    this.salesOrderService.createActivity(createTaskTimelineInput).subscribe({
      next: (data: any) => {
        this.toastr.success('Activity added successfully');
        this.activityForm.reset();
        this.dialogRef.close();
      },
      error: (error: any) => {
        this.toastr.error(error?.message);
      },
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
